import { Box, Stack, TextField, Autocomplete, Typography } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import {
  HOME_GLASS_BACKDROP,
  HOME_GLASS_BORDER,
} from "../../../../pages/Home/constants/homeGlass";
import {
  THEME_ACCENT,
  textFieldSx,
  StepSectionTitle,
  FieldLabel,
} from "./shared";

export default function ClientDetailsStep({
  form,
  setForm,
  domains,
  domainsLoading,
  open,
  activeStep,
}) {
  return (
    <>
      <StepSectionTitle icon={PersonOutlineIcon}>Client Details</StepSectionTitle>
      <Typography
        sx={{ fontSize: 12, color: "rgba(255,255,255,0.45)", mb: 2, lineHeight: 1.5 }}
      >
        Enter the basic information for this client workspace.
      </Typography>
      <Stack spacing={1.5}>
        <Box>
          <FieldLabel>Client Name</FieldLabel>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Enter client name"
            value={form.clientName}
            onChange={(e) => setForm((p) => ({ ...p, clientName: e.target.value }))}
            autoFocus={open && activeStep === 0}
            InputProps={{
              endAdornment: (
                <PersonOutlineIcon
                  sx={{ fontSize: 18, color: "rgba(255,255,255,0.3)", mr: 0.5 }}
                />
              ),
            }}
            sx={textFieldSx}
          />
        </Box>
        <Box>
          <FieldLabel>Industry</FieldLabel>
          <Autocomplete
            freeSolo
            options={domains.map((d) => d.domainName).filter(Boolean)}
            loading={domainsLoading}
            inputValue={form.domainName}
            onInputChange={(_, value) => {
              const trimmed = value.trim();
              const match = domains.find(
                (d) =>
                  String(d.domainName ?? "").toLowerCase() === trimmed.toLowerCase(),
              );
              setForm((p) => ({
                ...p,
                domainName: value,
                domainId: match?.domainId ?? null,
              }));
            }}
            onChange={(_, value) => {
              const name = String(value ?? "").trim();
              const match = domains.find((d) => d.domainName === name);
              setForm((p) => ({
                ...p,
                domainName: name,
                domainId: match?.domainId ?? null,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                placeholder="Select or enter domain"
                InputProps={params.InputProps}
                sx={textFieldSx}
              />
            )}
            slotProps={{
              paper: {
                sx: {
                  bgcolor: "rgba(28, 29, 22, 0.96)",
                  backdropFilter: HOME_GLASS_BACKDROP,
                  border: HOME_GLASS_BORDER,
                  color: "#fff",
                  "& .MuiAutocomplete-option": {
                    fontSize: 14,
                    "&[aria-selected='true']": { bgcolor: `${THEME_ACCENT}33` },
                    "&.Mui-focused": { bgcolor: "rgba(255,255,255,0.06)" },
                  },
                },
              },
            }}
          />
        </Box>
      </Stack>
    </>
  );
}
